/**
 * @description Component-PortfolioPositionTable
 */
import './index.less';

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { usePositionListByUser } from '@/features/account/positionHook';
import { useIsFetchedPortfolioList } from '@/features/portfolio/hook';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import TradePositionTable from '@/pages/trade/TradePositionTable';
interface IPropTypes {
  children?: React.ReactNode;
  className?: string;
}
const PortfolioPositionTable: FC<IPropTypes> = function ({}) {
  const { t } = useTranslation();
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const positions = usePositionListByUser(chainId, userAddr, false);
  const isFetchedPortfolio = useIsFetchedPortfolioList(chainId, userAddr);
  if (isFetchedPortfolio && !positions?.length) {
    return null;
  }
  return (
    <>
      <div className="syn-portfolio-position-table">
        <div className="title">{t('common.positions')}</div>
        {/* <SkeletonTable
          loading={isMockSkeleton || !isFetchedPortfolio}
          columns={columnDefs as SkeletonTableColumnsType[]}>
          <Table
            columns={columnDefs}
            dataSource={positions}
            rowKey={(record) =>
              record.id +
              record.rootPair.rootInstrument?.isNormalInstrument?.toString() +
              record.rootPair.isNormalPair?.toString()
            }
            pagination={false}
            emptyDesc={t('common.empty.TradeNow')}
            emptyDescLink={'/#/trade'}
            showUnconnected={false}
            // antd site header height
            sticky={{ offsetHeader: 56 }}
            rowClassName={(record: WrappedPosition) =>
              classNames({
                emergency: !record.rootPair.rootInstrument?.isNormalInstrument,
                odd: _.indexOf(instruments, record.rootInstrument.displaySymbol) % 2 !== 0,
              })
            }
            onRow={(record: WrappedPosition) => {
              return {
                onClick: () => {
                  if (!record.rootPair.isNormalPair) {
                    chainId &&
                      userAddr &&
                      dispatch(clickOpenSettledPairModal({ chainId, userAddr, portfolio: record.rootPortfolio }));
                    return;
                  }
                  gtag('event', 'enter_trade', {
                    entrance: 'portfolio', // link, nav_bar, market, portfolio, odyssey_place_limit_order
                  });
                  pairPageNavigate(record.rootPair.symbol || '', PAIR_PAGE_TYPE.TRADE, record.rootPair.chainId);
                },
              };
            }}
          />
        </SkeletonTable> */}
        <TradePositionTable isTradePage={false} />
      </div>
    </>
  );
};

export default PortfolioPositionTable;
